import React from 'react';
import cx from 'classnames';

interface DatePickerProps {
    id: string;
    className?: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const DatePicker: React.FC<DatePickerProps> = ({
    id,
    className,
    value,
    onChange,
    placeholder
}) => {
    return (
        <input
            type="date"
            id={id}
            className={cx(
                'form-input block w-full rounded-md border-gray-300 shadow-sm',
                'focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm',
                'dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100',
                className
            )}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
        />
    );
}; 